module.exports = __webpack_public_path__ + "img/hot-dish.af617c9f.svg";